import * as Yup from 'yup';
import { ERROR_MESSAGES } from '@/shared/constants/error-messages';
import { passwordValidation, PhoneAndRequired } from '@/shared/helpers/validations';

const unsupportedEmailProviders = ['icloud.com', 'mac.com', 'me.com'];
export const validationSchema = Yup.object({
    password: passwordValidation,
    email: Yup.string()
        .email(ERROR_MESSAGES.VALID_EMAIL)
        .required(ERROR_MESSAGES.REQUIRED_FIELD_MISSING)
        .test(
            'unsupported-email-provider',
            "We're sorry, but we cannot send emails to this email address. Please use a different email address to continue.",
            value => {
                if (value) {
                    const domain = value.split('@')[1];
                    return !unsupportedEmailProviders.includes(domain);
                }
                return true;
            }
        ),
    phoneNumber: PhoneAndRequired(Yup.string())
});
